module.exports = __webpack_public_path__ + "static/banner-9cf060c2426139e345489cbff1c56c79.png";